import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import React from "react";

function Copyright() {
    return (
        <Typography variant="body2" color="text.secondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://6plus.bg/">
                6 Плюс
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
export default Copyright;